import { render, staticRenderFns } from "./UploadFileForm.vue?vue&type=template&id=06507dcf&scoped=true"
import script from "./UploadFileForm.vue?vue&type=script&lang=ts"
export * from "./UploadFileForm.vue?vue&type=script&lang=ts"
import style0 from "./UploadFileForm.vue?vue&type=style&index=0&id=06507dcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06507dcf",
  null
  
)

export default component.exports